module.exports = __webpack_public_path__ + "static/Webshort-8cc77fef456ab9e8699922a48f1e4b23.mp4";